import React, { useEffect, useRef, useState } from "react";
import LabelNumber from "../../../styled-components/LabelNumber";
import ValueGraphChart from "./ValueGraphChart";
import LabelText from "../../../ui/LabelText";
import SecondaryButton from "../../../ui/SecondaryButton";
import IApiResponse from "../../../types/IApiResponse";
import { fetchData, postData } from "../../../services/api";
import { IPlayerCardData, IPlayerTranfer } from "../../../types/IPlayerDetail";
import handleApiResponse from "../../../utils/handleApiResponse";
import apiUrls from "../../../config/apiUrls";
import { useLoading } from "../../../contexts/LoadingContext";
import DrawerComponent from "../../../ui/Drawer";
import FullViewContent from "./FullViewContent";
import ValueGraphFilterSection from "./ValueGraphFilterSection";
import { useSearch } from "../../../contexts/PlayerSearchContext";
import ValueGraphChartForThirds from "./ValueGraphChartForThirds";
import InjuryRecord from "../Attributes/InjuryRecord";
import { IInjuryRecord } from "../../../types/IInjuryData";
import PlayerTranfer from "../Attributes/PlayerTransfer";
import { IAttributesVeap, IEventsByPlayerVeap, IValueGraph, IValueSeasonGraphChart } from "../../../types/IValueGraphChart";
import ValueGraphChartForSeasons from "./ValueGraphChartForSeasons";
import { fetchTransferValueSeasonBenchmark } from './ValueGraphUtils'
import { IPlayerAttributesData, IPlayingStats } from "../../../types/IPlayerAttributesData";
import CustomDropdown from "../../../ui/CustomDropdown";
import { FormationData, IOption } from "../../../types/IOption";
import AttributesOnPitch from "./AttributesOnPitch";
import styled from "styled-components";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { RolesPlayed } from "../Attributes/RolesPlayed";
import { PlayerSystemFit } from "./PlayerSystemFit";
import YellowCardSvg from '../../../assets/event_icons/Yellow Card.svg';
import RedCardSvg from '../../../assets/event_icons/Red Card.svg'
import { ModuleSpinner } from "../../../ui/LoadingSpinner/ModuleSpinner";
import Dot from '../../../assets/icons/playing-stat-dot.svg';
import HeaderTextWithIcon from "../HeaderTextWithIcon";
import { EmptyData } from "../Attributes/Tags";
interface ICareerAttributeProps {
  playerId: number;
  playerName: string;
  playerData: IPlayerCardData | undefined;
}

const StyledTags = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
gap: 16px;
flex: 1 0 0;
border-radius: 8px;
border: 1px solid var(--Warm-Grey-warm-grey-300, #DADADA);
`;
export const PlayerTagsData = styled.div<{ background: string }>`
  padding: 8px 12px 8px 12px;
  border-radius: 4px;
  background: ${({ background }) => background}; //var(--Shades-Brand-Green-2-green-2-200, #ACF8C0);
  font-family: DM Mono;
  font-size: 10px;
  font-weight: 500;
  line-height: 10px;
  text-align: center;

  & .player-data-text {
    color: #111111;
    text-align: center;
    font-feature-settings: "clig" off, "liga" off;
    /* DM-Mono/Label/Small */
    font-family: "DM Mono";
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 10px; /* 100% */
    text-transform: uppercase;
  }
`;

const MarketValueContainer = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.playerDataBorder};
  .secondary-cta-text {
    padding-right: 0px;
  }
`;

const ValueGraphContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.playerDataBorder};

`;


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  "& .clubLogoSVG": {
    filter:
      theme.mode === "light"
        ? "invert(46%) sepia(100%) saturate(1989%) hue-rotate(1deg) brightness(104%) contrast(106%)"
        : "invert(59%) sepia(84%) saturate(2319%) hue-rotate(127deg) brightness(100%) contrast(101%)",
  },
  [`&.${tableCellClasses.head}`]: {
    fontSize: 16,
    color: theme.NumberColor,
    fontWeight: 500,
    fontFamily: "Aeonik",
    borderBottom: `1px solid ${theme.playerDataBorder}`,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    color: theme.playerDataValueColor,
    fontFamily: "DM Mono",
    border: 0,
    fontWeight: 500,
    textTransform: "uppercase",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: theme.playerCardBackground,
    border: 0,
  },
}));


const options = ['Matches', 'Seasons'];
const onthePitchOption = ['Attributes', 'Playing Style', 'System fit']

const OverView: React.FC<ICareerAttributeProps> = ({ playerId, playerName, playerData }) => {
  const { startLoading, stopLoading, moduleLoading, setModuleLoading } = useLoading();
  const { selectedAttr, setSelectedAttr, isInfocard, setIsInfoCard , setSelectedGraph} = useSearch();
  const { seasonId, setSeasonId, isTransferMarket, setIsTransferMarket, isVolatility, setVolatility, selectedOption, setSelectedOption} = useSearch();
  const [activeSection, setActiveSection] = React.useState<"MarketValue" | "Transfers" | "InjuryRecord">("MarketValue");
  const sectionRefs = {
    MarketValue: useRef<HTMLDivElement>(null),
    Transfers: useRef<HTMLDivElement>(null),
    InjuryRecord: useRef<HTMLDivElement>(null),
  };
  const [transferValueData, setTransferValueData] = useState<IValueGraph | undefined>();
  const [transferValueSeasonData, setTransferValueSeasonData] = useState<IValueSeasonGraphChart | undefined>();
  const [isFullViewOpen, setIsFullViewOpen] = useState<boolean>(false);
  const [injuryData, setInjuryData] = useState<IInjuryRecord | undefined>();
  const [playerTransferData, setPlayerTransferData] = useState<IPlayerTranfer[]>([]);
  const playerTransferRef = useRef<HTMLDivElement | null>(null);
  const [selectedPosition, setSelectedPosition] = useState<"theirposition" | "allpositions">("theirposition");
  const [selectedAttributeScore, setSelectedAttributeScore] = useState<string>("league");
  const [attributesData, setAttributesData] = useState<IPlayerAttributesData | undefined>();
  const [seasonData, setSeasonData] = useState<IOption[]>([]);
  const [playingStatSeasonData, setPlayingStatSeasonData] = useState<IOption[]>()
  const [careerStatSeasonData, setCareerStatSeasonData] = useState<IOption[]>()
  const [currentSeason, setcurrentSeason] = useState<string>();
  const [currentTeamlogoURL, setCurrentTeamLogoUrl] = useState<string[]>([]);
  const [playingStatsData, setPlayingStatsData] = useState<IPlayingStats>();
  const [careereStatData, setCareerStatData] = useState<IPlayingStats>();
  const [currentPlayingStatSeason, setCurrentPlayingStatSeason] = useState<string>();
  const [currentPlayingStatTeamLogoURl, setcurrentPlayingStatTeamLogoURl] = useState<string[]>([])
  const [currentCareerSeason, setCurrentCareerSeason] = useState<string>();
  const [currentCareerTeamLogoURl, setcurrentCareerTeamLogoURl] = useState<string[]>([])
  const [playingStatSeasonId, setPlayingStatSeasonId] = useState<number>(0)
  const [careerSeasonId, setCareerSeasonId] = useState<number>(0)
  const [playingStatLoaing, setPlayingStatLoading] = useState<boolean>(false)
  const [formationData, setFormationData] = useState<FormationData[]>([]);
  const [slectedOnthePitchOption, setSelectedOnthePitchOption] = useState<string>('Attributes')
  const [eventsByPlayerVeapData, setEventsByPlayerVeapData] = useState<{ name: string; videoUrl: string }[]>([]);
  const [teamId, setTeamId] = useState<number>();

  useEffect(() => {
    if (isFullViewOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isFullViewOpen]);

  useEffect(() => {
    // setSelectedOption('Matches')
    const handleScroll = () => {
      const windscroll = window.scrollY;
      Object.entries(sectionRefs).forEach(([section, ref]) => {
        const element = ref.current;
        if (element) {
          const sectionTop = element.getBoundingClientRect().top + window.scrollY;
          const sectionHeight = element.offsetHeight;
          const header = document.querySelector(".page-header") as HTMLElement | null;
          const tabs = document.querySelector(".tab-section") as HTMLElement | null;

          const headerHeight = header?.offsetHeight || 0;
          const tabsHeight = tabs?.offsetHeight || 0;
          const offset = 3;
          if (windscroll >= sectionTop - headerHeight - tabsHeight - offset && windscroll < sectionTop + sectionHeight - 200) {
            setActiveSection(section as "MarketValue" | "Transfers" | "InjuryRecord");
          }
        }
      });
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const fetchTransferValueBenchmark = async () => {
      setModuleLoading(true);
      try {
        const response: IApiResponse<IValueGraph> = await fetchData(`${apiUrls["TransferValueBenchmark"]}?PlayerId=${playerId}`);
        handleApiResponse(
          response,
          (valueData) => {
            setModuleLoading(false);
            setTransferValueData(valueData);
          },
          (error) => {
            console.error("Error fetching transfer value data:", error);
          }
        );
      } catch (error) {
        console.error("Error fetching transfer value benchmark:", error);
      } finally {
        setModuleLoading(false);
      }
    };

    const fetchEventByPlayerBestVeap = async () => {
        setModuleLoading(true);
        try {
          const response: IApiResponse<IEventsByPlayerVeap> = await fetchData(
            `${apiUrls["GetEventByPlayerBestVeap"]}?playerId=${playerId}&seasonId=${seasonId}`
          );

          handleApiResponse(
            response,
            (data) => {
              setModuleLoading(false);

              if (data) {
                const combined: IAttributesVeap[] = [
                  ...(data.defencive || []),
                  ...(data.buildUpPlay || []),
                  ...(data.finalThird || [])
                ];
                const top3 = combined.slice(0, 3);
                const formatted = top3.map((item) => ({
                  name: item.attributeName,
                  videoUrl: `${apiUrls["GetVideoClipByFileName"]}?filename=${item.fileName}`
                }));

                setEventsByPlayerVeapData(formatted);
              }
            },
            (error) => {
              console.error("Error fetching eventsByPlayerVeap data:", error);
            }
          );
        } catch (error) {
          console.error("Error fetching eventsByPlayerVeap Data:", error);
        } finally {
          setModuleLoading(false);
        }
    };

  //fetchTransferValueBenchmark
  useEffect(() => {
    // setSelectedAttr('Finishing - Shots')
    setSelectedOnthePitchOption('Attributes')
    setSelectedOption('Matches')
    setTransferValueSeasonData(undefined)
    setIsInfoCard(false)
    fetchTransferValueBenchmark();
  }, [playerId]);

  useEffect(() => {
    const fetchSeasonData = async () => {
      const response: IApiResponse<any> = await fetchData(`${apiUrls["GetAllCompetitionSeasonsByPlayerId"]}?PlayerId=${playerId}`);
      handleApiResponse(
        response,
        (teamsData) => {
          // Format the incoming data
          const formattedData = teamsData.map((item: any) => ({
            value: String(item.value),
            label: item.label,
            teams: item.teams,
          }));

          // Create the "Career" entry
          const careerOption: IOption = {
            value: "0",
            label: "Career",
            teams: [],
          };

          // Prepend career and set state
          const updatedData = [careerOption, ...formattedData];
          setPlayingStatSeasonData(updatedData)
          setCareerStatSeasonData(updatedData)
          setSeasonData(teamsData);
          const currentSeasonValue = teamsData[0]?.value;
          const currentSeason = teamsData[0]?.label;
          const currentTeamLogoUrl = teamsData[0]?.teams?.map((team: any) => team.teamLogoURL)
          setCurrentTeamLogoUrl(currentTeamLogoUrl)
          setcurrentPlayingStatTeamLogoURl(currentTeamLogoUrl)
          setcurrentCareerTeamLogoURl(currentTeamLogoUrl)
          setSeasonId(Number(currentSeasonValue));
          setTeamId(Number(teamsData[0]?.teams?.map((team: any) => team.teamId)));
          setPlayingStatSeasonId(Number(currentSeasonValue))
          setCareerSeasonId(Number(0))
          setcurrentSeason(currentSeason);
          setCurrentPlayingStatSeason(currentSeason)
          setCurrentCareerSeason('Career')
        },
        (error) => {
          console.error("Error fetching season Data:", error);
        }
      );
    };
    const fetchPlayerTransfer = async () => {
      try {
        const ApiRequestData = {
          playerId: playerId,
        };
        const response: IApiResponse<IPlayerTranfer[]> = await postData(apiUrls.GetPlayerTransfers, ApiRequestData);
        handleApiResponse(
          response,
          (playerTransfer) => {
            setPlayerTransferData(playerTransfer);
          },
          (error) => {
            console.error(error);
          }
        );
      } catch (error) {
        console.error("Error fetching player tranfer data:", error);
      }
    };

    const fetchInjuryData = async () => {
      try {
        const ApiRequestData = {
          playerId: playerId,
        };
        const response: IApiResponse<IInjuryRecord> = await postData(apiUrls.GetInjuryRecord, ApiRequestData);
        handleApiResponse(
          response,
          (injuryData) => {
            setInjuryData(injuryData);
          },
          (error) => {
            console.error(error);
          }
        );
      } catch (error) {
        console.error("Error fetching player card data:", error);
      }
    };

    const fetchAllData = async () => {
      startLoading();
      try {
        await Promise.all([
          fetchPlayerTransfer(),
          fetchInjuryData(),
        ]);
      } catch (error) {
        console.error("Error fetching player data:", error);
      } finally {
        stopLoading();
      }
    };

    fetchAllData();
    fetchSeasonData();
    // fetchTransferValueSeasonBenchmark(setModuleLoading, setTransferValueSeasonData, playerId);
  }, [playerId]);

  useEffect(() => {

    const fetchAttributesData = async () => {
      // if (seasonId > 0) {
      try {
        startLoading();
        const ApiRequestData = {
          playerId: playerId,
          AllPosition: selectedPosition === "allpositions",
          AttributeScoreFor: selectedAttributeScore,
          seasonId: seasonId,
        };
        const response: IApiResponse<IPlayerAttributesData> = await postData(apiUrls.GetPlayerAttributes, ApiRequestData);
        handleApiResponse(
          response,
          (attributesData) => {
            setAttributesData(attributesData);
            stopLoading();
          },
          (error) => {
            console.error(error);
            stopLoading();
          }
        );
      } catch (error) {
        stopLoading();
        console.error("Error fetching PlayerAttributes data:", error);
      }
      // }
    };
    fetchAttributesData();
  }, [playerId, seasonId, selectedAttributeScore]);

  useEffect(() => {

    const fetchPlayingstats = async () => {
      setPlayingStatLoading(true);
      // const seasonId =
      try {
        const response: IApiResponse<IPlayingStats> = await fetchData(`${apiUrls["GetPlayingstats"]}?playerId=${playerId}&seasonId=${playingStatSeasonId!}`);
        handleApiResponse(
          response,
          (responseData) => {
            if(response.isSuccess) {
            setPlayingStatLoading(false);
            setPlayingStatsData(responseData);
            }
          },
          (error) => {
            console.error("Error fetching Playingstats data:", error);
          }
        );
      } catch (error) {
        console.error("Error fetching Playingstats:", error);
      } finally {
        setPlayingStatLoading(false);
      }
    };

    setTimeout(async () => {
          fetchPlayingstats();

      }, 1000); // 1000 ms delay

  }, [playerId, playingStatSeasonId])

  useEffect(() => {
    const fetchPlayingstats = async () => {
      setPlayingStatLoading(true);
      // const seasonId =
      try {
        const response: IApiResponse<IPlayingStats> = await fetchData(`${apiUrls["GetPlayingstats"]}?playerId=${playerId}&seasonId=${careerSeasonId!}`);
        handleApiResponse(
          response,
          (responseData) => {
            if(response.isSuccess){
              setPlayingStatLoading(false);
              setCareerStatData(responseData);
            }
            
          },
          (error) => {
            console.error("Error fetching Playingstats data:", error);
          }
        );
      } catch (error) {
        console.error("Error fetching Playingstats:", error);
      } finally {
        setPlayingStatLoading(false);
      }
    };

    fetchPlayingstats();

  }, [playerId, careerSeasonId])

  useEffect(() => {
    const updatedPlayingStatOptions = playingStatSeasonData?.map(option => ({
      ...option,
      disabled: option.value === careerSeasonId.toString()
    }));

    const updatedCareerOptions = careerStatSeasonData?.map(option => ({
      ...option,
      disabled: option.value === playingStatSeasonId.toString()
    }));

    setPlayingStatSeasonData(updatedPlayingStatOptions || []);
    setCareerStatSeasonData(updatedCareerOptions || []);
  }, [careerSeasonId, playingStatSeasonId]);


  useEffect(()=>{
    const fetchPlayerFormationsData = async () => {
      setPlayingStatLoading(true);
      // const seasonId =
      
      try {
        const response: IApiResponse<FormationData[]> = await fetchData(`${apiUrls["GetPlayerFormation"]}?playerId=${playerId}&seasonId=${seasonId!}`);
        handleApiResponse(
          response,
          (formationData) => {
            setPlayingStatLoading(false);
            // setFormationData(responseData);
            if (formationData.length > 0) {
              setFormationData(formationData.slice(0,2));
            } else {
              setFormationData([]);
            }
          },
          (error) => {
            console.error("Error fetching Player Formations data:", error);
          }
        );
      } catch (error) {
        console.error("Error fetching Player Formations Data:", error);
      } finally {
        setPlayingStatLoading(false);
      }
    };

    fetchPlayerFormationsData();
    if(playerData?.clubId === 16470 || playerData?.clubId === 16511 || playerData?.clubId === 16471)
    {
        fetchEventByPlayerBestVeap();
    }
  },[playerId, seasonId,playerData?.clubId])


  const handleOptionsClick = (option: string) => {
    setSelectedGraph('Football')
    setSelectedOption(option)
    // if (!transferValueSeasonData) { 
      if(option === 'Seasons' && !transferValueSeasonData){
      fetchTransferValueSeasonBenchmark(setModuleLoading, setTransferValueSeasonData, playerId) 
      }
    // }
  }

  const handleonthePitchOptionClick = (option: string) => {
    setSelectedOnthePitchOption(option)
  }

  // const handleSeasonChange = (seasonId: string) => {
  //   setSeasonId(Number(seasonId));
  // };

  const handleSeasonChange = (seasonId: string, teamId?: string) => {
    setSeasonId(Number(seasonId));
    setTeamId(Number(teamId));
  };


  const handlePlayingStatSeasonChange = (seasonId: string) => {
    setPlayingStatSeasonId(Number(seasonId))
  }

  const handleCareerSeasonChange = (seasonId: string) => {
    setCareerSeasonId(Number(seasonId))

  }


  const getBackgroundColor = (value?: number): string => {
    if (value == null) {
      return "none";
    }
    value = Math.ceil(value);
    if (value > 0 && value <= 24.99) {
      return "var(--UI-red-500, #FF3864)";
    } else if (value >= 25 && value <= 49.99) {
      return "var(--Brand-orange-500, #FF7800)";
    } else if (value >= 50 && value <= 74.99) {
      return "var(--UI-yellow-500, #F2E94E)";
    } else if (value >= 75 && value <= 87.99) {
      return "#C9F0B6";
    } else if (value >= 88 && value <= 98.99) {
      return "var(--Brand-green-2-500, #4AF075)";
    } else if (value >= 99) {
      return "#00D1A8";
    } else if (value === 0) {
      return "#DADADA";
    } else {
      return "red";
    }
  };

  const getBackgroundFormationColor = (usagePercentage?: number) => {
    if (usagePercentage! >= 0 && usagePercentage! <= 19) return "#FF3864";
    if (usagePercentage! >= 20 && usagePercentage! <= 39) return "#FF7800";
    if (usagePercentage! >= 40 && usagePercentage! <= 59) return "#F2E94E";
    if (usagePercentage! >= 60 && usagePercentage! <= 100) return "#4AF075";
    return "#F2F5EE"; // Default color if usagePercentage is out of range
};


  return (
    <div className="player-tab-content">
      <div className="career-container">
        <div className="career-main-content" >
          <div className="market-value-section">
            <MarketValueContainer className="market-value-container">
              <div className="onpitch-dropdown">
                <LabelText className="drawer-title">On the Pitch</LabelText>
                <div className="custom-dropdown season-drodown" style={{ flexDirection: attributesData?.playerTeamsForSeason?.length! > 1 ? "column" : "row", border: 'none', paddingBottom: '0px', zIndex: 1 }}>
                  <CustomDropdown
                    placeholder="SEASON"
                    options={seasonData}
                    onChange={handleSeasonChange}
                    deafaultSelected={currentSeason}
                    currentLogo={currentTeamlogoURL}
                    fromAttributes={true}
                    isDisplaySearchInput={false}
                    Id={playerId}
                  />
                </div>
              </div>
              <div className="career-market-value-buttons">
                {onthePitchOption.map(option => (
                  <SecondaryButton
                    key={option}
                    label={option}
                    isSelected={slectedOnthePitchOption === option}
                    onClick={() => handleonthePitchOptionClick(option)}
                  />
                ))}
              </div>
            </MarketValueContainer>
            {slectedOnthePitchOption === "Attributes" && (
              <AttributesOnPitch attributesData={attributesData!} playerId={playerId} seasonId={seasonId} />
            )}
            
            {slectedOnthePitchOption === "Playing Style" && (
              <RolesPlayed playerName={playerName} playerId={playerId} seasonId={seasonId} />
            )}
            {slectedOnthePitchOption === "System fit" && (
              <PlayerSystemFit playerId={playerId} seasonId={seasonId} teamId={teamId!} playerData={playerData} timeframe={currentSeason!} />
            )}
          </div>
          {(playerData?.clubId === 16470 || playerData?.clubId === 16511 || playerData?.clubId === 16471) && (
              <div style={{display:'flex', alignItems:'center',gap:'20px'}}>
                {eventsByPlayerVeapData.flatMap((event, index) => (
                  <div style={{display:'flex',flexDirection:'column'}}>
                    <LabelText className="player-detail-given-name">{event?.name}</LabelText>
                    <video
                      key={event?.videoUrl}
                      controls
                      autoPlay
                      muted
                      loop
                      style={{ width: '420px',border: '2px solid #000', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)'}}>
                        <source src={event?.videoUrl} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                  </div>
                ))}

              </div>
          )}
          
          <div className="market-value-section" style={{ position: 'relative' }}>
            
            <MarketValueContainer className="market-value-container">
              <LabelText className="drawer-title">Playing stats</LabelText>

            </MarketValueContainer>
            {/* {playingStatsData !== undefined && careereStatData !== undefined && ( */}
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow style={{ backgroundColor: '#F9FAF7' }}>
                      <StyledTableCell ></StyledTableCell>
                      <StyledTableCell >
                        <div className="custom-dropdown season-drodown" style={{ flexDirection: attributesData?.playerTeamsForSeason?.length! > 1 ? "column" : "row", border: 'none', paddingBottom: '0px', zIndex: 0 }}>
                          <CustomDropdown
                            placeholder=""
                            options={playingStatSeasonData}
                            onChange={handlePlayingStatSeasonChange}
                            deafaultSelected={currentPlayingStatSeason}
                            currentLogo={currentPlayingStatTeamLogoURl}
                            isDisplaySearchInput={false}
                            fromPlayingstat={true}
                            Id={playerId}
                          />
                        </div>
                      </StyledTableCell>
                      <StyledTableCell ><div className="custom-dropdown season-drodown" style={{ flexDirection: attributesData?.playerTeamsForSeason?.length! > 1 ? "column" : "row", border: 'none', paddingBottom: '0px', zIndex: 0 }}>
                        <CustomDropdown
                          placeholder=""
                          options={careerStatSeasonData}
                          onChange={handleCareerSeasonChange}
                          deafaultSelected={currentCareerSeason}
                          currentLogo={currentCareerTeamLogoURl}
                          isDisplaySearchInput={false}
                          fromPlayingstat={true}
                          Id={playerId}
                        />
                      </div>
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>


                    <StyledTableRow>
                      <StyledTableCell><LabelNumber className="attack-defense-data">Mins played</LabelNumber></StyledTableCell>
                      <StyledTableCell><LabelNumber className="playing-stats-data">{playingStatsData?.totalMinutesOnField}</LabelNumber></StyledTableCell>
                      <StyledTableCell><LabelNumber className="playing-stats-data">{careereStatData?.totalMinutesOnField}</LabelNumber></StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell><LabelNumber className="attack-defense-data">% time Injured</LabelNumber></StyledTableCell>
                      <StyledTableCell><LabelNumber className="playing-stats-data">{playingStatsData?.playerInjuredPercent}%</LabelNumber></StyledTableCell>
                      <StyledTableCell><LabelNumber className="playing-stats-data">{careereStatData?.playerInjuredPercent}%</LabelNumber></StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell><LabelNumber className="attack-defense-data">Attack Contribution</LabelNumber></StyledTableCell>
                      <StyledTableCell><div className="playing-stat-contribution" style={{ backgroundColor: getBackgroundColor(playingStatsData?.contributionValue) }}><LabelNumber className="playing-stats-data">{(playingStatsData?.contributionValue === 100 ? 99: playingStatsData?.contributionValue)}</LabelNumber></div></StyledTableCell>
                      <StyledTableCell><div className="playing-stat-contribution" style={{ backgroundColor: getBackgroundColor(careereStatData?.contributionValue) }}><LabelNumber className="playing-stats-data">{(careereStatData?.contributionValue === 100 ? 99 : careereStatData?.contributionValue)}</LabelNumber></div></StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell><LabelNumber className="attack-defense-data">Total Goals <img src={Dot} />  Penalties</LabelNumber></StyledTableCell>
                      <StyledTableCell><LabelNumber className="playing-stats-data">{playingStatsData?.totalGoals} <img src={Dot} /> {playingStatsData?.totalPenalties}</LabelNumber></StyledTableCell>
                      <StyledTableCell><LabelNumber className="playing-stats-data">{careereStatData?.totalGoals} <img src={Dot} /> {careereStatData?.totalPenalties}</LabelNumber></StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell><LabelNumber className="attack-defense-data">assists</LabelNumber></StyledTableCell>
                      <StyledTableCell><LabelNumber className="playing-stats-data">{playingStatsData?.totalAssists}</LabelNumber></StyledTableCell>
                      <StyledTableCell><LabelNumber className="playing-stats-data">{careereStatData?.totalAssists}</LabelNumber></StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell><LabelNumber className="attack-defense-data">x Goals</LabelNumber></StyledTableCell>
                      <StyledTableCell><LabelNumber className="playing-stats-data">{playingStatsData?.averageXGoals.toFixed(2)}</LabelNumber></StyledTableCell>
                      <StyledTableCell><LabelNumber className="playing-stats-data">{careereStatData?.averageXGoals.toFixed(2)}</LabelNumber></StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell><LabelNumber className="attack-defense-data">X assists</LabelNumber></StyledTableCell>
                      <StyledTableCell><LabelNumber className="playing-stats-data">{playingStatsData?.averageXAssists.toFixed(2)}</LabelNumber></StyledTableCell>
                      <StyledTableCell><LabelNumber className="playing-stats-data">{careereStatData?.averageXAssists.toFixed(2)}</LabelNumber></StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell><LabelNumber className="attack-defense-data">FOULS SUFFERED</LabelNumber></StyledTableCell>
                      <StyledTableCell><LabelNumber className="playing-stats-data">{playingStatsData?.foulsSuffered}</LabelNumber></StyledTableCell>
                      <StyledTableCell><LabelNumber className="playing-stats-data">{careereStatData?.foulsSuffered}</LabelNumber></StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell><LabelNumber className="attack-defense-data">FOULS Committed</LabelNumber></StyledTableCell>
                      <StyledTableCell><LabelNumber className="playing-stats-data">{playingStatsData?.foulsCommitted}</LabelNumber></StyledTableCell>
                      <StyledTableCell><LabelNumber className="playing-stats-data">{careereStatData?.foulsCommitted}</LabelNumber></StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell><LabelNumber className="attack-defense-data">Cards</LabelNumber></StyledTableCell>
                      <StyledTableCell> <img src={YellowCardSvg} alt="YellowCardSvg" />&nbsp;
                        <LabelNumber className="playing-stats-data">{playingStatsData?.totalYellowCards}</LabelNumber>
                        &nbsp;&nbsp;
                        <img src={RedCardSvg} alt="RedCardSvg" />&nbsp;
                        <LabelNumber className="playing-stats-data">{playingStatsData?.totalRedCards}</LabelNumber>
                        &nbsp;&nbsp;</StyledTableCell>
                      <StyledTableCell> <img src={YellowCardSvg} alt="YellowCardSvg" />&nbsp;
                        <LabelNumber className="playing-stats-data">{careereStatData?.totalYellowCards}</LabelNumber>
                        &nbsp;&nbsp;
                        <img src={RedCardSvg} alt="RedCardSvg" />&nbsp;
                        <LabelNumber className="playing-stats-data">{careereStatData?.totalRedCards}</LabelNumber>
                        &nbsp;&nbsp;</StyledTableCell>

                    </StyledTableRow>

                  </TableBody>

                </Table>

              </TableContainer>
            {/* )} */}
            
            {playingStatLoaing && (<ModuleSpinner />)}
          </div>
          <div ref={sectionRefs.MarketValue} id="market" className="market-value-section">
            <MarketValueContainer className="market-value-container">
              <LabelText className="drawer-title">Market Value</LabelText>
              <div className="career-market-value-buttons">
                {options.map(option => (
                  <SecondaryButton
                    key={option}
                    label={option}
                    isSelected={selectedOption === option}
                    onClick={() => handleOptionsClick(option)}
                  />
                ))}
              </div>
            </MarketValueContainer>
            <ValueGraphContainer className={`value-graph-container ${isFullViewOpen && "fullview-container"}`}>
              <ValueGraphFilterSection
                isTransferMarket={isTransferMarket}
                isVolatility={isVolatility}
                toggleTransferMarket={() => setIsTransferMarket(!isTransferMarket)}
                toggleVolatility={() => setVolatility(!isVolatility)}
              />
              {selectedOption === "Matches" && (
                <ValueGraphChart transferValueData={transferValueData} playerId={playerId} isFullView={isFullViewOpen} isLoading={moduleLoading} />
              )}
              {selectedOption === "Seasons" && (
                <ValueGraphChartForSeasons transferValueSeasonData={transferValueSeasonData} isFullView={isFullViewOpen} isLoading={moduleLoading} />
              )}
              {selectedOption === "Thirds" && (
                <ValueGraphChartForThirds transferValueData={transferValueData} isFullView={isFullViewOpen} isLoading={moduleLoading} />
              )}
            </ValueGraphContainer>
            <div className="expanded-view-btn">
              <SecondaryButton
                iconType="expandedview"
                label="Expanded view"
                onClick={() => {
                  setIsFullViewOpen(true);
                }}
              />
            </div>
            {isFullViewOpen && (
              <DrawerComponent
                open={isFullViewOpen}
                onClose={() => {
                  setIsFullViewOpen(false);
                }}
                styleVariant="value-graph"
                customClassName="career-drawer-main career-drawer"
              >
                <FullViewContent
                  selectedOption={selectedOption}
                  transferValueData={transferValueData}
                  transferValueSeasonData={transferValueSeasonData}
                  onClose={() => {
                    setIsFullViewOpen(false);
                  }}
                  isFullView={isFullViewOpen}
                  playerId={playerId}
                  setTransferValueSeasonData={setTransferValueSeasonData}
                />
              </DrawerComponent>
            )}
          </div>
          <div className="tags-formations-container">
                <StyledTags>
                  <div className="player-tags-wrapper">
                    <HeaderTextWithIcon text="Tags" isFromOverview={true} isIcon={false}/>
                    <div className="tags-centent">
                      {attributesData?.tags === null && (
                        <EmptyData className="tags-empty-data">
                          <LabelText className="empty-data-text">No tags currently apply to this player</LabelText>
                        </EmptyData>
                      )}
                      {attributesData?.tags?.map((tag, index) => (
                        <PlayerTagsData key={index} background={tag.isPositive ? "#4AF075" : "#FF7900"}>
                          <span className="player-data-text">{tag.tagName}</span>
                        </PlayerTagsData>
                      ))}
                    </div>
                  </div>
                </StyledTags>
                <StyledTags>
                  <div className="player-tags-wrapper" style={{height:attributesData?.tags !== null ? '' : '164px'}}>
                    <HeaderTextWithIcon text="Favoured formations" isFromOverview={true} isIcon={false}/>
                    <div className="tags-centent" style={{flexDirection:'row'}}>
                      {/* {formationData?.length === 0 && (
                        <EmptyData className="tags-empty-data">
                          <LabelText className="empty-data-text">No tags currently apply to this player</LabelText>
                        </EmptyData>
                      )} */}
                      {formationData.map((formation) => (
                          <div className="club-formation-content" key={formation.id} style={{ backgroundColor: getBackgroundFormationColor() }}>
                              <LabelNumber className="goal-assist-name">{formation.formation}</LabelNumber>
                              <LabelNumber className="goal-assist-name">
                                  {"•  played : " + (formation.usagePercentage > 0 ? formation.usagePercentage : "") + (formation.usagePercentage > 0 ? "%" : '')}
                              </LabelNumber>
                          </div>
                      ))}
                    </div>
                  </div>
                </StyledTags>
          </div>
          <div ref={sectionRefs.Transfers} id="transfers" className="section">
            <PlayerTranfer data={playerTransferData} playerTransferRef={playerTransferRef} />
          </div>
          <div ref={sectionRefs.InjuryRecord} id="injury" className="section">
            <InjuryRecord injuryData={injuryData} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverView;